export class ActiveFixedEntryEntity {
     
    id: number;
    identification: string;
    name: string;
    area: string;
    position: string;
    equipment: string;
    serial: string;
    serialEquipment: string;
    creationDate: Date;
    userId:number;
    personEntry: string;
    associatedSerial: string;
    observation: string;

    constructor () {}
}